import AV from 'leancloud-storage'


var APP_ID = 'sfOze4Cqs8zxKSKSFj5Wdlz1-gzGzoHsz';
var APP_KEY = 'hJBMKrFXHivE2Bkk5zFwWXpJ';

AV.init({
  appId: APP_ID,
  appKey: APP_KEY
});
  

export default AV



// WEBPACK FOOTER //
// ./src/lib/leancloud.js